// TODO: #646 refactor -- split to view and container, rename the folder

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTranscriptEntryById } from '@actions/conference';
import { TRANSCRIPT_VIEW_TYPES } from '@config/transcriptViewConfig';
import { TranscriptView } from '@templates';
import { BasicPage } from '@layout';

export class TranscriptAdminPreviewPage extends PureComponent {
  componentDidMount() {
    const { computedMatch, getTranscriptEntryById: getTranscriptEntry } = this.props;
    const isAIRoute = computedMatch.path === '/transcript/ai/view/:id';
    getTranscriptEntry(computedMatch.params.id, isAIRoute);
  }

  render() {
    const { computedMatch } = this.props;
    const isAIRoute = computedMatch.path === '/transcript/ai/view/:id';
    return (
      <BasicPage>
        <TranscriptView
          mode={TRANSCRIPT_VIEW_TYPES.ADMIN_PREVIEW}
          isAIRoute={isAIRoute}
        />
      </BasicPage>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  getTranscriptEntryById,
};

TranscriptAdminPreviewPage.propTypes = {
  getTranscriptEntryById: PropTypes.func.isRequired,
  computedMatch: PropTypes.object,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranscriptAdminPreviewPage);



// WEBPACK FOOTER //
// ./components/pages/transcriptAdminPreviewPage/TranscriptAdminPreviewPage.js